import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { SharingDataService } from './Services/sharing-data.service';
import { AuthenticationRole, AuthentService } from './Services/authent.service';
import { FormularService } from './Services/formular.service';
import { CommonService } from './Services/common.service';

import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';

export const globalFormRoot = new FormGroup({});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private shareData: SharingDataService,
    public authService: AuthentService,
    public formularService: FormularService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  public formGroupRoot: FormGroup;

  title = 'DBYDPortal';

  resourceDefinition;
  Picklist;
  gipDefault;
  showLoading = true;
  isActivateAccount;
  hash: string = '';
  private adminMode;
  private user;

  picklists = [
    { tableName: "V_MS_SALUTATION_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_TITLE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_ACTIVITY_TYPE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_DELIVERY_STATE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_PROCESSING_STATE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_REASON_TYPE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_REQUEST_STATE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_SEARCH_METHOD_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_SEARCH_METHOD_INT_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_GIP_BOOL_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: false },
    { tableName: "GIP_LANG", text: ["LANG"], key: "LANG", language: false, ordinal: false },
    { tableName: "V_GIP_DOCTYPE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: false },
    { tableName: "V_MS_SERVICE_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: true },
    { tableName: "V_MS_EXPORT_SERVICE", text: ["G3E_USERNAME"], key: "G3E_ELNO", language: true, ordinal: false },
    { tableName: "V_MS_CONTRACT_VL", text: ["VALUE"], key: "VID", language: false, ordinal: false },
    { tableName: "V_MS_COMPANY_VL", text: ["VALUE"], key: "VID", language: false, ordinal: false },
    { tableName: "V_GIP_NUMBOOL_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: false },
    { tableName: "MS_DEF_SCALE", text: ["SCALE"], key: "ID", language: false, ordinal: false },
    { tableName: "V_MS_FORMAT_VL", text: ["VALUE"], key: "VID", language: false, ordinal: false },
    { tableName: "V_GIP_VALIDITY_VL_T", text: ["VALUE"], key: "VID", language: true, ordinal: false },
    { tableName: "V_MS_FEATURE_VL_T", text: ["G3E_USERNAME"], key: "G3E_FNO", language: true, ordinal: false },
    { tableName: "GIP_ROLE_T", text: ["DESCRIPT"], key: "ROLE", language: true, ordinal: false },
    { tableName: "MS_REQSERVICE_STATUS_VL_T", text: ["STATUS"], key: "VID", language: true, ordinal: false },
  ]


  ngOnInit() {
    this.formGroupRoot = globalFormRoot;
    this.shareData.currentUser.subscribe((data) => this.user = data);
    
    this.router.events
    .subscribe((event: RoutesRecognized) => {
      const url = event.url;
      if (url != undefined && url.includes("activateaccount")){
        this.isActivateAccount = true;
        this.hash = url.split('/')[2];
      }
    });

    this.getLanguage();
  }

  getLanguage() {
    var lang = (navigator.language).substr(0, 2).toUpperCase();
    var actualLang = localStorage.getItem("Language");
    var defaultLang = "";
    this.commonService.getData([`metadata/GIP_LANG`], (data) => {
      var table = data[0];
      var isLanguageInTable = false;
      var isActualLanguageInTable = false;
      table.forEach(element => {
        if (element.LANG == actualLang) {
          isActualLanguageInTable = true;
        }
        if (element.LANG == lang) {
          isLanguageInTable = true;
        }
        if (element.DEFAULT == "1") {
          defaultLang = element.LANG;
        }
      });
      if (isActualLanguageInTable) {
        this.getConfiguration(actualLang);
      } else if (isLanguageInTable) {
        this.getConfiguration(lang);
      } else {
        this.getConfiguration(defaultLang);
      }
    });
  }

  activateFalse(){
    this.isActivateAccount = false;
  }



  getConfiguration(language) {
    this.shareData.changeLanguage(language);
    localStorage.setItem("Language", language);

    var urls = [
      `configuration/V_GIP_RESOURCE_T?$filter=LANG eq '${language}'`,
      `admin/V_GIP_DEFAULT_T`,
    ]

    this.picklists.forEach(element => {
      var url = "";
      if (element.language) {
        url = `?$filter=LANG eq '${language}'`
      }
      if(element.ordinal){
        if(url != ""){
          url += `&$orderby=ORDINAL`;
        } else {
          url += `?$orderby=ORDINAL`;
        }
      }
      urls.push(`picklist/${element.tableName}/Get${url}`)
    });

    this.commonService.getPicklist(urls, (data) => {
      this.resourceDefinition = data[0].value;
      this.shareData.changeResourceDefinition(this.resourceDefinition);

      this.gipDefault = data[1].value;
      this.shareData.changeGipDefault(this.gipDefault);

      this.Picklist = new Array();

      let count = 2;
      for (var picklistElement of this.picklists) {
        this.Picklist[picklistElement.tableName] = new Array();
        data[count].forEach(resElement => {
          var picklistText = ""
          picklistElement.text.forEach(textElement => {
            if (picklistText != "") {
              picklistText += " ";
            }
            picklistText += resElement[textElement]
          });
          let object = {
            key: resElement[picklistElement.key],
            text: picklistText,
            unused: resElement.UNUSED
          }

          this.Picklist[picklistElement.tableName].push(object);
        });
        this.shareData.changePicklist(this.Picklist);

        count++;
      }

      if (this.authService.currentUser() != null) {
        this.authService.setUser();
      } else {
        this.showLoading = false;
      }
      this.showLoading = false;
    })
  }
}
